module.exports = false; // Only Node.JS has a process variable that is of [[Class]] process

try {
  module.exports = Object.prototype.toString.call(global.process) === '[object process]';
} catch (e) {}